import { AppModule } from '@libs/fsc/models/AppModule'

import routes from './routes'

export const UsersCore = new AppModule('Users', routes)
